import {
	type HttpVerb,
	getHttpServiceMeta,
	setHttpAuthRequired,
	setHttpBasePath,
	setHttpMethodMeta,
	setHttpParamSource,
} from './http-metadata';

function normalizePath(path: string): string {
	const trimmed = path.trim();
	if (!trimmed) return '';
	return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

export function httpRoute(basePath: string): ClassDecorator {
	return (target) => {
		setHttpBasePath(target as unknown as Function, normalizePath(basePath));
	};
}

export function httpRequireAuth(): ClassDecorator & MethodDecorator {
	return (target: object, propertyKey?: string | symbol) => {
		// Method decorator
		if (propertyKey !== undefined) {
			const ctor = (target as { constructor: Function }).constructor;
			setHttpMethodMeta(ctor, String(propertyKey), {
				...(getExistingMethodMetaOrDefault(ctor, String(propertyKey))),
				authRequired: true,
			});
			return;
		}

		// Class decorator
		setHttpAuthRequired(target as unknown as Function, true);
	};
}

function getExistingMethodMetaOrDefault(ctor: Function, methodName: string): { verb: HttpVerb; path: string } {
	const meta = getHttpServiceMeta(ctor);
	const existing = meta.methods[methodName];
	if (existing) return { verb: existing.verb, path: existing.path };
	return { verb: 'GET', path: `/${methodName}` };
}

function createHttpMethodDecorator(verb: HttpVerb, path: string): MethodDecorator {
	return (target, propertyKey) => {
		const ctor = (target as { constructor: Function }).constructor;
		setHttpMethodMeta(ctor, String(propertyKey), { verb, path: normalizePath(path) });
	};
}

export function httpGet(path: string): MethodDecorator {
	return createHttpMethodDecorator('GET', path);
}

export function httpPost(path: string): MethodDecorator {
	return createHttpMethodDecorator('POST', path);
}

export function httpArg(name?: string): ParameterDecorator {
	return (target, propertyKey, parameterIndex) => {
		if (propertyKey === undefined) return;
		const ctor = (target as { constructor: Function }).constructor;
		setHttpParamSource(ctor, String(propertyKey), parameterIndex, { kind: 'arg', name });
	};
}

export function httpBodyArg(): ParameterDecorator {
	return (target, propertyKey, parameterIndex) => {
		if (propertyKey === undefined) return;
		const ctor = (target as { constructor: Function }).constructor;
		setHttpParamSource(ctor, String(propertyKey), parameterIndex, { kind: 'body' });
	};
}

export function httpUserId(): ParameterDecorator {
	return (target, propertyKey, parameterIndex) => {
		if (propertyKey === undefined) return;
		const ctor = (target as { constructor: Function }).constructor;
		setHttpParamSource(ctor, String(propertyKey), parameterIndex, { kind: 'userId' });
	};
}

export function optionalHttpUserId(): ParameterDecorator {
	return (target, propertyKey, parameterIndex) => {
		if (propertyKey === undefined) return;
		const ctor = (target as { constructor: Function }).constructor;
		setHttpParamSource(ctor, String(propertyKey), parameterIndex, { kind: 'userIdOptional' });
	};
}


